import { ExternalLink } from "@octopusdeploy/design-system-components";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
import { EmptyStateDeploymentFreezesIllustration } from "./EmptyStateDeploymentFreezesIllustration";
export const DeploymentFreezeOnboardingPage = () => {
    return (<OnboardingPage title="You have no deployment freezes scheduled" intro={"Add a deployment freeze to get started"} learnMore={<ExternalLink href="DeploymentFreezes">Learn more</ExternalLink>} image={<EmptyStateDeploymentFreezesIllustration />}/>);
};
